@let view = data();

@if (view.link.href) {
  <a [link]="view.link" uiContentLink uiPageBlockLinkClick>
    <ng-container *ngTemplateOutlet="card"></ng-container>
  </a>
} @else {
  <ng-container *ngTemplateOutlet="card"></ng-container>
}

<ng-template #card>
  <mat-card uiPageBlockImpression matRipple>
    @if (view.icon; as icon) {
      <div class="icon">
        <ui-icon
          [faName]="icon.name"
          [faStyle]="icon.style"
        />
      </div>
    } @else if (view.iconSvg) {
      <div [innerHTML]="view.iconSvg | bypassSecurity" class="icon"></div>
    }

    <h3><strong>{{ view.headline }}</strong></h3>

    <div [innerHTML]="view.content"></div>

    @if (view.link.label; as label) {
      <div class="link">{{ label }}</div>
    }
  </mat-card>
</ng-template>
